<!-- <sf-smartquote-nav></sf-smartquote-nav> -->

<sf-smartquote-search
    [existingFilter]="smartQuoteHelperService.filter()"
    (onSearchClicked)="onFilterChange($event)"></sf-smartquote-search>

<sf-card>
    @if (smartQuotes$ | async; as quotesPaged) {
        @if (quotesPaged.items.length) {
            <sf-smartquote-table [smartQuotes]="quotesPaged.items"></sf-smartquote-table>
            <sf-pagination-detail
                [paginationData]="quotesPaged"
                (onPageChange)="onPageChange($event)"></sf-pagination-detail>
        } @else {
            <sf-empty
                message="There are no Smart Quotes to show, change your query parameters and try again."></sf-empty>
        }
    }
</sf-card>
